"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DeliveryLinear = function DeliveryLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 12a2.4 2.4 0 11-4.8 0h-.8A1.6 1.6 0 010 10.4V4a1.6 1.6 0 011.6-1.6h6.08A1.6 1.6 0 019.28 4v.009c.057-.006.116-.01.175-.01h2.26c.434 0 .846.165 1.122.448l2.708 2.779c.292.299.455.7.455 1.117l-.001 2.426c0 .68-.652 1.23-1.455 1.23H14.4a2.4 2.4 0 11-4.8 0H7.2zm.48-8.32H1.6a.32.32 0 00-.32.32v6.4c0 .177.143.32.32.32h1.17a2.398 2.398 0 014.06 0H8V4a.32.32 0 00-.32-.32zm6.864 7.04h-.514a2.398 2.398 0 00-4.06 0h-.69l.001-5.4a.363.363 0 01.174-.04h2.26c.126 0 .195.05.205.06l2.709 2.78c.058.06.09.14.09.223v2.337a.363.363 0 01-.175.04zM5.92 12a1.12 1.12 0 11-2.24 0 1.12 1.12 0 012.24 0zm7.2 0a1.12 1.12 0 11-2.24 0 1.12 1.12 0 012.24 0z",
    fill: "currentColor"
  }));
};

exports.DeliveryLinear = DeliveryLinear;
var _default = DeliveryLinear;
exports.default = _default;